import React from "react";
import ReactDOM from "react-dom";
import {
  SiteContextProvider,
} from "@arcteryx/components-contexts";
import { GlobalStyles } from "@arcteryx/components-typography";
import {
  TagManagerScript,
  UIHeader,
} from "@arcteryx/components-universal";
import { getFrontendDeployEnv } from "../../helpers";

const categoryProperties = {
  "env": getFrontendDeployEnv(),
  "market": ARCTERYX.WEBSITE_SETTINGS.MARKET.toLowerCase(),
  "country": ARCTERYX.WEBSITE_SETTINGS.COUNTRY.toLowerCase(),
  "language": ARCTERYX.WEBSITE_SETTINGS.LANG.toLowerCase(),
  "uiBaseUrl": ARCTERYX.WEBSITE_SETTINGS.UI_BASE_URL.toLowerCase(),
};

ReactDOM.render(
  <SiteContextProvider
    market={categoryProperties.market}
    country={categoryProperties.country}
    language={categoryProperties.language}
  >
    <GlobalStyles />
    <UIHeader uiBaseUrl={categoryProperties.uiBaseUrl} env={categoryProperties.env} />
    <TagManagerScript env={categoryProperties.env} />
  </SiteContextProvider>,
  document.querySelector( "#header" )
);
